<template>
  <div class="custom-label relative">
    <ml-input :readonly="!editMode" v-model="label"/>
    <feather-icon v-if="!readonly && !editMode" class="cursor-pointer" icon="EditIcon" @click="editMode = !editMode" />
    <feather-icon v-else-if="!readonly && editMode" class="cursor-pointer" icon="XIcon" @click="editMode = !editMode" />
  </div>
</template>

<script>
export default {
  name: "CustomLabel",
  props: {
    value: String,
    readonly: Boolean,
    // label 이 공백일 경우 초기화 될 값
    initLabel: String,
  },
  watch: {
    value(value) {
      this.label = value || this.initLabel
    },
    editMode(value) {
      if (!value) {
        if (!this.label) {
          this.label = this.initLabel
        }
        this.$emit("input", this.label);
      }
    },
  },
  data() {
    return {
      editMode: false,
      label: this.value,
    }
  },
}
</script>

<style scoped>
.feather-icon {
  position: absolute !important;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);

  padding-left: 4px;
  border-left: 1px solid #e5e7eb;
}
</style>

<style>
.custom-label .ml-input > .vs-con-input > .vs-inputx {
  padding-right: 36px !important;
}
</style>
